import { motion } from 'framer-motion';
import { ExternalLink, Award } from 'lucide-react';

const VELUX_BG = 'https://images.pexels.com/photos/30739544/pexels-photo-30739544.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260';

export const VeluxSection = ({ settings }) => {
  if (!settings?.velux_active) return null;

  return (
    <section id="velux" className="relative py-24 md:py-36 overflow-hidden" data-testid="velux-section">
      {/* Background */}
      <div className="absolute inset-0">
        <img src={VELUX_BG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0077D4]/85" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="flex-shrink-0"
          >
            <div className="w-40 h-40 md:w-48 md:h-48 border-4 border-white/30 flex flex-col items-center justify-center text-center p-6">
              <Award size={40} className="text-[#CC2229] mb-3" />
              <span className="font-heading text-2xl font-black text-white uppercase tracking-tight">VELUX</span>
              <span className="text-white/70 text-xs uppercase tracking-widest mt-1">Experte</span>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="text-center lg:text-left"
          >
            <span className="section-label text-[#CC2229]">Partner</span>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black text-white mt-4 tracking-tight uppercase">
              {settings?.velux_title || 'VELUX Experte'}
            </h2>
            <p className="text-slate-300 text-base sm:text-lg mt-6 max-w-xl leading-relaxed">
              {settings?.velux_description || 'Als zertifizierter VELUX Experte beraten wir Sie kompetent rund um Dachfenster.'}
            </p>

            {settings?.velux_link ? (
              <a
                href={settings.velux_link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-[#CC2229] text-white px-10 py-5 font-bold uppercase tracking-wider text-sm mt-10 hover:bg-[#a31b20] transition-all duration-300 hover:translate-y-[-2px] hover:shadow-xl"
                data-testid="velux-configurator-link"
              >
                Zum VELUX Konfigurator <ExternalLink size={18} />
              </a>
            ) : (
              <div className="mt-10 inline-flex items-center gap-2 text-white/50 text-sm border border-white/20 px-8 py-4" data-testid="velux-placeholder">
                <ExternalLink size={16} /> Konfigurator-Link wird eingerichtet
              </div>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
};
